import * as React from 'react';
import { useGlobalClassName } from './use_global_classname.js';

/**
 * Provides the current active theme name and variables to its subtree.
 */
const ThemeProvider = ({ children, currentTheme, themes, onThemeChange, getIconPath }) => {
    const classNameMap = React.useMemo(() => {
        return Object.keys(themes).reduce((prev, current) => {
            const { className } = themes[current];
            return {
                ...prev,
                [current]: Array.isArray(className) ? className : [className],
            };
        }, {});
    }, [themes]);
    useGlobalClassName(currentTheme, classNameMap);
    const contextValue = React.useMemo(() => ({ currentTheme, themes, onThemeChange, getIconPath: getIconPath ?? ((name) => `#${name}`) }), [currentTheme, themes, onThemeChange, getIconPath]);
    return React.createElement(ThemeContext.Provider, { value: contextValue }, children);
};
const ThemeContext = React.createContext({
    currentTheme: null,
    themes: null,
    getIconPath: (name) => `#${name}`,
});

export { ThemeContext, ThemeProvider };
